import styled from "styled-components";
import { Colors } from "../../styles/consts";

export const DivContent = styled.div`
display: flex;
align-items: baseline;
`

export const Result = styled.p`
color: ${Colors.PRIMARY_BLUE};
font-size: 28px;
font-weight: 700;
margin-right: 10px;

margin-bottom: 25px;

`

export const Unit = styled.span`

font-size: 18px;
color: ${Colors.PRIMARY_BLUE};
`